import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import Logo from '@/UI/Logo';
import './borrow.less';
import { Helmet } from 'react-helmet';
import Phone from '@/UI/Phone';

export default function Layout(props: {
    pageName?: string;
    children: JSX.Element | JSX.Element[];
}): ReactElement {
    const { children = null, pageName } = props;

    return (
        <div className={`body-wrapper borrow ${pageName || ''}`}>
            <Helmet>
                <title>Funding.com.au</title>
            </Helmet>
            <div className='top-bar'>
                <Link to='/'>
                    <Logo className='logo' />
                </Link>
                <a className='contact-phone' href='tel:1300443319'>
                    <div className='phone-content'><Phone className='icon' />1300 44 33 19</div>
                </a>
            </div>
            {children}
            <div className='footer-wrapper'>
                <div className='footer'>
                    <strong>DISCLAIMER</strong>
                    <p>Lending criteria, fees and conditions apply. For consumer or personal loans please refer to our <a href='https://www.funding.com.au/credit-guide/' rel='noreferrer' target='_blank'>Credit Guide</a> for more information. See <a href='https://www.funding.com.au/privacy-policy/' rel='noreferrer' target='_blank'>Privacy</a>, <a href='https://www.funding.com.au/terms-of-use/' rel='noreferrer' target='_blank'>Terms</a>, <a href='https://www.funding.com.au/credit-guide/' rel='noreferrer' target='_blank'>Credit Guide</a>, <a className='link' href='https://www.funding.com.au/tmd-credit'>Target Market Determination (Credit).</a></p>
                    <p>Funding.com.au Pty Ltd A.B.N. 33 603 756 547.</p>
                    <p>Funding Commercial Pty Ltd A.C.N. 634 414 127 is a lending entity of business/commercial loans.</p>
                    <p>Funding Pty Ltd A.C.N. 607 035 861 Australian Credit Licence 483665 is a lending entity of consumer/personal loans.</p>
                </div>
            </div>
        </div>
    );
}

